import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

export const Leaf = ({
  width = 8,
  height = 11,
  fillColor = '#ffffff',
  style
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 9 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M6.86899 7.68667C8.43622 5.89556 8.81344 0 8.81344 0C7.93853 0.456795 6.99844 0.728595 6.03872 0.802222C4.43455 0.957778 2.94899 1.21778 2.07011 2.21333C0.734273 3.75111 0.397884 5.93333 1.164 7.47778C2.00399 5.97333 5.46705 3.81556 5.46705 3.81556C2.98205 5.84667 0.125662 9.70222 0.0109396 10.1956C-0.103783 10.6889 0.718717 10.7067 0.84705 10.4511C0.975384 10.1956 1.46927 9.16667 2.01372 8.54667C3.36899 9.64667 5.43983 9.32222 6.86899 7.68667Z"
        fill={fillColor}
      />
    </svg>
  );
};